import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 94vh;
  background: #fcfcfc;
  padding: 25px 75px 50px 70px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 4px;
    background-color: #fcfcfc;
  }

  ::-webkit-scrollbar-thumb {
    background: #11a7d9;
    -webkit-border-radius: 1ex;
    -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);
  }

  ::-webkit-scrollbar-corner {
    background: #11a7d9;
  }
`;

export const FormContainer = styled.div`
  width: 550px;
`

export const ReturnLink = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  margin-bottom: 20px;

  p {
    color: #11A7D9;
    font-family: "Open Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    text-decoration-line: underline;
    margin: 0;
  }
`

export const Title = styled.h3`
  color: #3A3A3C;
  font-family: "Open Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 170%;
  margin-bottom: 24px;
`

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 15px;
`
export const SwitchContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;

  p {
    color: #6C6C6C;
    font-family: "Open Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin: 0;
  }
`

export const Label = styled.div`
  color: #444;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;

  span {
    display: flex;
    align-items: center;
    margin-left: 5px;
  }
`;

export const NumericalInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`;

export const NumericalInfoText = styled.p`
  display: block;
  margin-top: 8px;
  margin-bottom: 0px;
`;

export const ImportErrorContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 16px;
  gap: 15px;
  width: 550px;

  div:first-child {
    margin-left: 0px;
  }

  .ant-btn-default {
    background: #002244;
    border-color: #002244;
    border-color: #002244;
    color: #fff;
  }

  .ant-btn-default:hover {
    background: #0d3252;
    border-color: #0d3252 !important;
  }
`;

export const BtnTemplate = styled.div`
  display: inline-flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 24px;

  .ant-btn-default {
    color: #11a7d9;
  }

  .ant-btn-default:hover {
    border-color: #40a9ff !important;
  }
`;
